import { useExploraDispatch, useExploraState } from 'app/store/explora-context';
import LoadingScreen from '../../shared/components/LoadingScreen/LoadingScreen';
import { ExploraRequestAction } from '../store/actions';
import React, { useEffect } from 'react';
import { EXPLORA_ROUTES } from 'app/explora-routes';
import TextBody from '../../shared/components/TextBody/TextBody';
import { FontColor, FontSize } from 'shared/styles/typography';
import './SitemapContainer.scss';

const SitemapContainer = () => {
  const dispatch = useExploraDispatch();
  const { blogContent } = useExploraState();
  useEffect(() => {
        if (blogContent.header.title.length === 0) {
          const getBlogContent = async () => {
            await ExploraRequestAction.getBlogContent(dispatch);
          };
    
          getBlogContent();
        }
      }, [dispatch, blogContent]);
    
      if (blogContent.header.title.length === 0) {
        return <LoadingScreen />;
      }
  return (
    <div className='sitemap-container'>
    <TextBody component="h1" color={FontColor.PrimaryLight} size={FontSize.ExtraExtraLarge}>
        Mapa del Sitio
    </TextBody>
    <ul>
    {blogContent.podcastingContent.map(blog => {
        return (
        <a href={`.${EXPLORA_ROUTES.Blog}/${blog.fields.url}`} key={blog.fields.url}>
        <li>
            {blog.fields.articleTitle}
        </li>
        </a>
        );})}
    </ul>
    </div>
  );
};

export default SitemapContainer;
